import { render, staticRenderFns } from "./error-message.vue?vue&type=template&id=3d51d643"
import script from "./error-message.ts?vue&type=script&lang=ts&external"
export * from "./error-message.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports